import { render, staticRenderFns } from "./formSlider.vue?vue&type=template&id=664162d0&"
import script from "./formSlider.vue?vue&type=script&lang=js&"
export * from "./formSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports